export default __webpack_public_path__ + "static/media/Transition_Start-Factory.15e56ceb.mp4";